import { getCookie } from '../utils/commonFunc';
import Http from './axios';
import Apollo from '@didi/apollo-sdk-javascript';

// 基本用户信息
export const getUserInfo = () => {
  return Http.get(`/user/info`).then((res) => {
    if (res.status === 2) {
      // 未登录状态
      let { redirectUrl } = res.data
      if (redirectUrl) {

        redirectUrl = redirectUrl.replace('jumpto', 'jumpto2') + '&jumpto=' + encodeURIComponent(window.location.href)

        window.location.href = redirectUrl
      }
    }
    return res
  })
}

// 获取个人信息接口
export const getPersonInfo = () => {
  return Http.get(`/mis/api/person/info`, {
    params: {
        lang: getCookie("lang").replace("-", "_"),
        userName: getCookie('user_name'),
    }
  });
}

// upm 权限
export const getPermissions = () => {
  return Http.get(`/ark/auth/getPermissions`)
}
// menu
export const getCSMemu = (params) => Http.get(`/menu/list/v2`, { params })
export const getOptimusMemu = (params) => Http.get(`/optimus/manager/auth/menu`, { params })

// 1.0跳转开量开关
export const getCountryPageJump = () => {
  return Http.get(`/ark/arkservice/apollo/getGrayPermission`, {
    params: {
      lang: getCookie("lang") && getCookie("lang").replace("-", "_"),
      settingKey: "grayOfflineWorkbench1.0",
    }
  })
}

// 新工单开量开关
export const getNewCSPermission = () => {
  return Http.get(`/ark/arkservice/apollo/getGrayPermission`, {
    params: {
      lang: getCookie("lang") && getCookie("lang").replace("-", "_"),
      settingKey: "grayPermissionWorkBench",
    }
  })
}

// 工作台2.1放量接口
export const getCrossCSPermission = () => {
  return Http.get(`/ark/arkservice/apollo/getSystemGrayPermission`, {
    params: {
      lang: getCookie("lang") && getCookie("lang").replace("-", "_"),
      settingKey: "crossGraySettingKey",
      system: "cs-cross",
    }
  })
}

// message
export const getMessageUserInfo = () => {
  return Http.get(`/notify/innerMsg/userInfo`)
}
export const getMessageInfo = (username) => {
  return Http.get(`/notify/innerMsg/list`, {
    params: {
      pageNum: 1,
      pageSize: 5,
      status: 2,
      isDelete: 0,
      sendTo: username
    }
  })
}
export const getUnreadMsgCount = () => {
  return Http.get(`/notify/innerMsg/unreadCount`)
}
export const setMsgReaded = (id) => {
  return Http.get(`/notify/innerMsg/unread`, {
    params: {
      id: id,
      isRead: 1
    }
  })
}
export const getUrgencyMessage = (username) => {
  return Http.get(`/notify/innerMsg/getUrgentMsg`, {
    params: {
      username
    }
  })
}


// 环境list
export const getEnvList = () => {
  return Http.get(`/auth/list/new`)
}
// 切换API环境
export const changeApiEnv = (env) => {
  return Http.get(`/menu/changeEnv?env=${env}`).then((res) => {
    if (res.status === 0) {
      window.location.reload()
      return
    }
    return res
  })
}

// 满意度接口
export const getUserSurveyDetail = () => {
  return Http.post(`/ark/common/getUserSurveyDetail`)
}

// 获取country国家列表
export const getCountryList = () => {
  return Http.get(`/auth/candidateCountry`)
}

// 获取country及时区列表
export const getCountryTimezoneNew = () => {
  return Http.get(`/global/getCountryTimezoneNew`)
}

// 获取模板国家列表
export const getModuleCountry = () => {
  return Http.get(`/ark/openCountry/getModuleCountry`)
}

// 更新国家 接口
export const getAllCountry = () => {
  return Http.get(`/ark/common/getAllCountry`)
}

// 国家模板国家 业务线 接口
export const getAllCountryAndOrg = () => {
  return Http.get(`/ark/common/getAllCountryAndOrg`)
}

// 获取金额精确度接口
export const getDigits = (params) => {
  return Http.get(`/ark/arkservice/common/getDigits`, { params })
}

// 工作状态接口
export const getStatusInit = () => {
  return Http.get(`/ark/staffStatus/init`)
}
export const changeStatus = (params) => {
  return Http.get(`/ark/staffStatus/changeStatus`, {
    params: {
      operationPosition: params.operationPosition,
      targetStatus: params.targetStatus
    }
  })
}
export const keepAlive = (hasOperation) => {
  return Http.get(`/ark/staffStatus/keepAlive`, {
    params: {
      hasOperation
    }
  })
}
export const changeSubStatus = (params) => {
  return Http.get(`/ark/staffStatus/changeSubStatus`, {
    params: {
      type: params.type,
      operationPosition: params.operationPosition,
      targetStatus: params.targetStatus
    }
  })
}



export const getViewByViewName = (params) => {
  const { viewName, fieldName, userId, lang } = params;
  return Http.get(`/ark/view/cross/getViewByViewName`, {
    params: {
      viewName,
      fieldName,
      userId,
      lang,
    }
  })
}

// 反馈提交接口
export const uploadFeedback = (params) => {
  return Http.post(`/ark/feedback/submit`, params)
}

// 获取Genesys 组织
export const genesysUserDetails = () => {
  return Http.get(`/gdata/genesysProxy/userName/${getCookie('user_name')}/userDetails`)
}

// 获取Genesys Presence映射关系
export const genesysMapping = (params) => {
  return Http.get(`/gdata/genesysProxy/presence/mappingByOrg`, {
    params: {
      // countryCode: getCookie("canonical_country_code"),
      genesysOrg: params.genesysOrg || 'didilatam',
      // genesysOrg: 'didiglobal1',
    }
  })
}

// 放量开关控制
export const getGrayPermissionList = () => {
  return Http.get(`/ark/arkservice/apollo/getGrayPermissionList`, {
    params: {
      userName: getCookie('user_name'),
      lang: getCookie("lang") && getCookie("lang").replace("-", "_"),
      settingKeys: "grayPermissionWorkbenchStatus",
    }
  })
}

// 工作状态接口
export const getStatusInit2 = (params) => {
  return Http.get(`/ark/staffStatus/initV3`, { params })
}
// 工作条状态变更
export const changeStatusV2 = (params) => {
  return Http.get(`/ark/staffStatus/changeStatusV3`, { params })
}
// 心跳检测
export const keepAlive2 = (params) => {
  return Http.get(`/ark/staffStatus/keepAliveV3`, { params })
}
// 在线/话后处理状态，客服操作记录
export const getActionRecord = (params) => {
  return Http.get(`/ark/staffStatus/actionRecordV3`, { params })
}
// 获取userid
export const getGenesysProxyInfo = () => {
  return Http.post(`/gdata/genesysProxy/presence/user/infoV3`, {
    genesysOrganization: "didiglobal1",
    name: getCookie('user_name'),
  })
}

// genesys下班
export const getGenesysOutofoffice = (params) => {
  return Http.post(`/gdata/genesysProxy/presence/user/outofoffice/update`, {
    name: getCookie('user_name'),
    ...params
  })
}

// 获取appolllo配置
export const getAppolloConfig = () => {
  Apollo.getToggle(
    {
      name: 'cs_fe_feat_sop_drag',
      key: 'username',
      global: true
    },
    function (result) {
      const cs_fe_feat_sop_drag =  result?.data?.[0]?.assign?.args || result?.data?.cs_fe_feat_sop_drag?.params || {};
      window._configData = {};
      const feat_sop_gray = {};
      feat_sop_gray.country_code =  cs_fe_feat_sop_drag?.country_code?.split?.(',') || [];
      feat_sop_gray.product_id =  cs_fe_feat_sop_drag?.product_id?.split?.(',') || [];
      feat_sop_gray.username =  cs_fe_feat_sop_drag?.username?.split?.(',') || [];
      window._configData.feat_sop_gray = feat_sop_gray;
    }
  );
}

// 获取客服服务类型
export function getServiceType () {
  return Http.get(`/mis/api/person/getServiceType`, { params: {
    mis: getCookie('user_name')
  } })
}

